import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import ADMIN_PATHS from "../ADMIN_PATHS";
import { Mail, FileText, ListChecks, Send } from "lucide-react";

const tabs = [
  {
    to: ADMIN_PATHS.MAIL_MANAGEMENT.TEMPLATES,
    label: "Email Templates",
    icon: FileText,
  },
  {
    to: ADMIN_PATHS.MAIL_MANAGEMENT.LOGS,
    label: "Email Logs",
    icon: ListChecks,
  },
  {
    to: ADMIN_PATHS.MAIL_MANAGEMENT.TEST,
    label: "Test Mail",
    icon: Send,
  },
  {
    to: ADMIN_PATHS.MAIL_MANAGEMENT.SETTINGS,
    label: "Email Settings",
    icon: Mail,
  },
];

const MailManagementLayout = () => (
  <div className="space-y-6">
    <header className="flex flex-col gap-4">
      <div className="flex items-center gap-3">
        <span className="h-8 w-1.5 rounded-full bg-[#D2042D]" aria-hidden="true" />
        <div>
          <h1 className="text-2xl font-black tracking-tight text-slate-900">Mail Management</h1>
          <p className="text-sm text-slate-600">
            Manage email settings, templates, logs, and test sends from one console.
          </p>
        </div>
      </div>
      <nav className="flex flex-wrap gap-2">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <NavLink
              key={tab.to}
              to={tab.to}
              className={({ isActive }) =>
                [
                  "inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-semibold transition-colors",
                  isActive
                    ? "border-[#D2042D]/20 bg-[#D2042D]/10 text-[#D2042D]"
                    : "border-slate-200 bg-white text-slate-700 hover:border-slate-300 hover:bg-slate-50",
                ].join(" ")
              }
            >
              <Icon size={16} className="shrink-0" />
              <span>{tab.label}</span>
            </NavLink>
          );
        })}
      </nav>
    </header>

    <Outlet />
  </div>
);

export default MailManagementLayout;
